import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getMenuListsConfigs() {
    return {
        palette: {
            [PALETTE_IDS.MINI_EVENT_ITEM]: {
                MINI_EVENT_ITEM_BG: COLOR.BRAND.BACKGROUND1,
                MINI_EVENT_ITEM_SELECTED_BG: COLOR.BRAND.ACCENT1,
                MINI_EVENT_ITEM_SELECTED_CONTENT: {
                    MINI_EVENT_ITEM_TIMING_STATUS: {
                        EVENT_TIMING_SEPARATOR_COLOR: COLOR.BRAND.FOREGROUND1,
                        EVENT_TIMING_LIVE_TEXT: COLOR.BRAND.FOREGROUND1,
                        EVENT_TIMING_UPCOMING_TEXT: COLOR.BRAND.FOREGROUND2,
                    },
                },
            },
            [PALETTE_IDS.QUICK_NAVIGATIONS]: {
                QUICK_NAVIGATIONS_BORDER: {
                    BORDER_RADIUS: 0,
                },
                QUICK_NAVIGATIONS_TITLE_TEXT: {
                    fontFamily: FONT.FAMILY,
                    color: COLOR.BRAND.FOREGROUND1,
                    fontSize: FONT.SIZE_MEDIUM,
                    fontWeight: FONT.WEIGHT_BOLD,
                    textTransform: 'capitalize',
                },
            },
            [PALETTE_IDS.MENUS_LINKS_LISTS]: {
                LHM_HEADER_BG: COLOR.BRAND.BACKGROUND4,
                LHM_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND5,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    textTransform: 'uppercase',
                    fontSize: FONT.SIZE_LARGE,
                },
            },
            [PALETTE_IDS.AZ_MENU]: {
                DESKTOP_AZ_EXPAND_BUTTON: {
                    TERTIARY_BUTTON_ICON_COLOR: COLOR.BRAND.ACCENT3,
                },
                MOBILE_AZ_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,
                MOBILE_AZ_SECTION_HEADER_TEXT: {
                    color: COLOR.BRAND.BACKGROUND7,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                MOBILE_AZ_ALL_SPORTS_BUTTON: {
                    TERTIARY_BUTTON_TEXT: {
                        color: COLOR.BRAND.ACCENT3,
                        fontWeight: FONT.WEIGHT_NORMAL,
                        textTransform: 'capitalize',
                    },
                },
            },
        },
    };
}
